<template>
  <div>
    <b-modal
      id="modal-prevent-closing"
      ref="generate-agreement-modal"
      centered
      title="Plan Generate Form"
      ok-title="Generate"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      @show="resetModal"
      @hidden="resetModal"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <h4 class="alert-heading">
            {{ $t('DEBITA_ERROR') }}
          </h4>
          <div class="alert-body">
            <span>{{ errorMsg }}</span>
          </div>
        </b-alert>
        <form
          ref="agreementform"
        >
          <validation-observer
            ref="infoRules"
            tag="form"
          >
            <b-row>
              <b-col md="12">
                <validation-provider
                  #default="{ errors }"
                  name="Send By"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_SEND_BY')"
                    label-for="send-by"
                    :state="errors.length > 0 ? false:null"
                  >
                    <v-select
                      ref="sendby"
                      v-model="sendBy"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="sendByOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="sendby"
                      @input="sendByChange"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="sendBy === 'email'"
                md="12"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-group
                    :label="$t('DEBTIA_EMAIL')"
                    label-for="email"
                    :state="errors.length > 0 ? false:null"
                  >
                    <b-form-input
                      id="email"
                      v-model="emailvalue"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Email"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="sendBy === 'sms'"
                md="12"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Phone Number"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_PHONE')"
                    label-for="phone-number"
                    :state="errors.length > 0 ? false:null"
                  >
                    <b-form-input
                      id="phone-number"
                      v-model="phonenumber"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Phone Number"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <div
                class="amount-period-base-divs"
              >
                <b-col
                  class="optionsClass"
                  md="12"
                >
                  <b-form-checkbox
                    v-model="amountBasePlan"
                    class="custom-control-primary"
                  >
                    {{ $t('DEBTIA_AMOUNT_BASE_PLAN') }}
                  </b-form-checkbox>
                </b-col>
                <b-col
                  v-if="amountBasePlan"
                  md="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_MIN_AMOUNT')"
                    label-for="min-amount"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Min. Amount"
                      rules="required"
                    >
                      <b-form-input
                        id="min-amount"
                        v-model="minAmount"
                        type="number"
                        placeholder="Min. Amount"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </div>
              <div
                class="amount-period-base-divs"
              >
                <b-col
                  class="optionsClass"
                  md="12"
                >
                  <b-form-checkbox
                    v-model="periodBasePlan"
                    class="custom-control-primary"
                  >
                    {{ $t('DEBTIA_PERIOD_BASE_PLAN') }}
                  </b-form-checkbox>
                </b-col>
                <b-col
                  v-if="periodBasePlan"
                  md="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_MAX_MONTH')"
                    label-for="max-month"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Max. Months"
                      rules="required"
                    >
                      <b-form-input
                        id="max-month"
                        v-model="maxMonth"
                        type="number"
                        placeholder="Max. Month"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </div>
              <b-col
                v-if="amountBasePlan || periodBasePlan"
                md="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_INTEREST_FREE_MONTHS')"
                  label-for="interest-free-months"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Interest Free Months"
                    rules="required"
                  >
                    <b-form-input
                      id="interest-free-months"
                      v-model="interestFreeMonths"
                      type="number"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Interest Free Months"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="amountBasePlan || periodBasePlan"
                md="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_INSTALLMENT_START_DATE')"
                  label-for="installment-start-date"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Installment Start Date"
                    rules="required|dateComparison"
                  >
                    <b-input-group>
                      <cleave
                        id="date"
                        v-model="dainstallmentStartDate"
                        class="form-control"
                        :raw="false"
                        :options="options.date"
                        placeholder="DD-MM-YYYY"
                        @input="validateDate(0, dainstallmentStartDate)"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          id="installment-start-date"
                          v-model="installmentStartDate"
                          button-only
                          right
                          :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                          trim
                          size="sm"
                          placeholder="Installment Start Date"
                          :state="errors.length > 0 ? false:null"
                          @input="validateDate(1, installmentStartDate)"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <label
                      id="dateerror"
                      style="color: red; display:none;"
                    >*{{ $t('DEBTIA_DATE_FORMAT_ERROR') }}</label>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInvalidFeedback, BFormInput, BFormDatepicker, BAlert, BOverlay, BFormCheckbox, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import axios from '@axios'
import Cleave from 'vue-cleave-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import { EventBus } from '@/event-bus'

export default {
  components: {
    BOverlay,
    BAlert,
    BRow,
    BCol,
    BFormInvalidFeedback,
    BFormInput,
    BFormGroup,
    // BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BFormCheckbox,
    BInputGroupAppend,
    BInputGroup,
    Cleave,
  },
  directives: {
    Ripple,
  },
  props: {
    journalId: {
      type: String,
      required: true,
    },
    caseId: {
      type: [Number, String],
      required: true,
    },
    mainDebtorEmail: {
      type: String,
      required: true,
    },
    mainDebtorPhone: {
      type: String,
      required: true,
    },
    modalClickTrigger: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      nameState: null,
      submittedNames: [],
      snowOption: {
        theme: 'snow',
      },
      decisionOptions: [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 },
      ],
      loader: false,
      phonenumber: '',
      emailvalue: '',
      required,
      sendBy: '',
      sendByOptions: [
        { label: 'Email', value: 'email' },
        { label: 'SMS', value: 'sms' },
      ],
      installmentStartDate: '',
      dainstallmentStartDate: '',
      interestFreeMonths: '',
      minAmount: '',
      maxMonth: '',
      amountBasePlan: 0,
      periodBasePlan: 0,
      constants,
      details: {},
      email,
      errorMsg: '',
      paymentClientId: '',
      paymentSecret: '',
      communications_client_id: '',
      communications_secret: '',
      sender_email: '',
      email_template_id: 0,
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
    }
  },
  watch: {
    modalClickTrigger: {
      handler() {
        // console.log('in here')
        this.errorMsg = ''
        this.getApiSettings()
        this.getCommunicationsApiSettings()
        this.getTemplateId()
      },
    },
  },
  created() {
    // this.getReasons()
  },
  methods: {
    validateDate(type, value) {
      if (type === 1) {
        // eslint-disable-next-line no-param-reassign
        value = this.$DAformattedDate(value)
      }
      const regex = /^\d{2}-\d{2}-\d{4}$/
      if (!regex.test(value)) {
        document.getElementById('dateerror').style.display = 'block'
      } else {
        if (type === 0) {
          this.installmentStartDate = this.$FormformattedDate(value)
        } else {
          this.dainstallmentStartDate = value
        }
        document.getElementById('dateerror').style.display = 'none'
      }
    },
    async getTemplateId() {
      await axios.get('/settings/get-default-action-template?action_id=9').then(settings => {
        if (settings.status) {
          this.email_template_id = settings.data.data.template_id
        }
      })
    },
    async getApiSettings() {
      await axios.get('/api-token/default?module=payments').then(settings => {
        if (settings.status) {
          this.payment_client_id = settings.data.data.client_id
          this.payment_secret = settings.data.data.secret
        }
      }).catch(err => {
        if (err.response.data.message) {
          const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
          this.errorMsg = msg
          this.alertErrors.push(err.response.data.message)
        }
      })
    },
    async getCommunicationsApiSettings() {
      await axios.get('/settings/get?module=communication').then(settings => {
        if (settings.status) {
          this.communications_client_id = settings.data.data.client_id
          this.communications_secret = settings.data.data.secret
          this.getSenderEmail()
        }
      }).catch(err => {
        if (err.response.data.message) {
          const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
          this.errorMsg = msg
          this.alertErrors.push(err.response.data.message)
        }
      })
    },
    getSenderEmail() {
      const headers = {
        clientId: this.communications_client_id,
        secret: this.communications_secret,
      }
      axios.get(`${constants.communicationBaseUrlV1}/email/get-user-mail-configs`, {
        headers,
      }).then(response => {
        if (response.status) {
          this.sender_email = response.data.data.mail_from_address
        }
      }).catch(err => {
        if (err.response.data.message) {
          const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
          this.errorMsg = msg
          this.alertErrors.push(err.response.data.message)
        }
      })
    },
    sendByChange(val) {
      if (val === 'email') {
        this.emailvalue = this.mainDebtorEmail
      } else {
        this.phonenumber = this.mainDebtorPhone
      }
    },
    resetModal() {
      this.sendBy = ''
      this.installmentStartDate = ''
      this.dainstallmentStartDate = ''
      this.interestFreeMonths = ''
      this.amountBasePlan = 0
      this.periodBasePlan = 0
      this.minAmount = ''
      this.maxMonth = ''
    },
    submitHandler(evt) {
      evt.preventDefault()
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            this.loader = true
            this.details.journal_id = this.journalId
            this.details.debtia_debt_case_id = this.caseId
            this.details.period_based_plan = this.periodBasePlan ? 1 : 0
            this.details.amount_based_plan = this.amountBasePlan ? 1 : 0
            this.details.max_months = this.maxMonth ? this.maxMonth : 0
            this.details.min_amount = this.minAmount ? this.minAmount : 0
            this.details.sender_email = this.sender_email
            this.details.interest_free_months = this.interestFreeMonths
            this.details.payment_method = 4
            this.details.payment_date = this.installmentStartDate
            this.details.send_method = this.sendBy
            this.details.debtor_email = this.emailvalue
            this.details.debtor_phone = this.phonenumber
            this.details.template_id = this.sendBy === 'sms' ? 213 : this.email_template_id
            this.details.employee_name = JSON.parse(localStorage.getItem('userData')).data.name
            const data = { ...this.details }
            const headers = {
              clientId: this.payment_client_id,
              secret: this.payment_secret,
            }
            axios.post(`${constants.paymentsBaseUrl}/installment_plan/generate_agreement_link`, data, {
              headers,
            }).then(response => {
              // console.log('response ', response)
              data.token = response.data.tokenized_url.split('/').pop()
              data.recipient_email = data.debtor_email
              data.recipient_phone = data.debtor_phone
              data.debt_case_id = this.caseId
              // save request data in local db table
              axios.post(`${constants.baseUrl}/installment-plan/save`, data).then(responseLocal => {
                if (responseLocal.status) {
                  EventBus.$emit('refreshLogs')
                  this.errorMsg = ''
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Success',
                      icon: 'CoffeeIcon',
                      variant: 'primary',
                      text: i18n.t('DEBTIA_AGREEMENT_LINK_GENERATION_SUCCESS'),
                    },
                  })
                  this.loader = false
                  this.$refs['generate-agreement-modal'].hide()
                }
              }).catch(err => {
                if (err.response.data.message) {
                  this.loader = false
                  const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
                  this.errorMsg = msg
                  this.alertErrors.push(err.response.data.message)
                }
              })

              // window.location.reload()
            }).catch(err => {
              if (err.response.data.message) {
                this.loader = false
                const msg = typeof err.response.data.message === 'string' ? err.response.data.message : err.response.data.message[0]
                this.errorMsg = msg
                this.alertErrors.push(err.response.data.message)
              }
            })
          } else {
            this.loading = false
            reject()
          }
        })
      })
    },
  },
  // mounted() {
  //   this.showModal()
  // },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.optionsClass {
  margin-bottom: 10px;
}

.amount-period-base-divs {
  width: 100%;
  padding: 15px 0px 5px 0px;
  border: 1px solid #d8d6dd;
  margin: 0px 15px 15px 15px;
  border-radius: 10px;
}
</style>
